// Letters about a record (docs/processes/12 «История»): what the outbox sent for this order, talk or ticket, newest first.

import { useMemo } from 'react';
import { formatDate, type Id } from '@confdeck/core-shared';
import { useMeta, useQuery, useSync } from '../sync/react.tsx';
import { Chip } from '../ui/primitives.tsx';
import s from './record.module.css';

export function Letters({ recordId, onOpen }: { recordId: Id; onOpen: (id: Id) => void }) {
  const meta = useMeta();
  const { store } = useSync();
  const type = meta.typeByKey('email_message');
  const filter = useMemo(() => ({ field: 'record', op: 'eq' as const, value: recordId }), [recordId]);
  const sort = useMemo(() => [{ field: 'createdAt', dir: 'desc' as const }], []);
  const q = useQuery(type?.id ?? '', filter, sort, '');
  if (!type) return <p className={s.empty}>Писем нет.</p>;
  if (!q.ids.length) return <p className={s.empty}>По этой записи писем не было.</p>;
  return (
    <div className={s.letters}>
      {q.ids.map((lid) => {
        const m = store.record(lid);
        if (!m) return null;
        const st = meta.term(String(m.data.status));
        return (
          <button key={lid} type="button" className={s.letter} onClick={() => onOpen(lid)}>
            <span className={s.letterMain}><span className={s.letterSubject}>{String(m.data.subject ?? '')}</span><span className={s.letterTo}>{String(m.data.to ?? '')} · {formatDate(m.createdAt)}</span></span>
            {st && <Chip color={st.color} dot>{st.name}</Chip>}
          </button>
        );
      })}
    </div>
  );
}
